


import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LocationPicker from "../Ordermanagment/Food/LocationPicker";
import { useLoader } from "../../../context/LoaderProvider";
import Modal from "../Ordermanagment/Food/Modal";
import axios from "axios";

// Section headings
const sections = [
  { title: "COMPANY DETAILS", startIndex: 0 },
  { title: "CONTACT DETAILS", startIndex: 5 },
  { title: "LICENSES & DOCUMENTS", startIndex: 9 },
  { title: "BANK DETAILS", startIndex: 14 }
];

const initialRowsConfig = [
  { key: "Company Name", value: "", isEditing: false, status: "Pending" },
  {
    key: "Business Vertical", value: "FOOD_AND_BEVERAGES", isEditing: false, status: "Pending", isDropdown: true,
    options: ["FOOD_AND_BEVERAGES"]
  },
  { key: "Position", value: "", isEditing: false, status: "Pending" },
  {
    key: "Vertical Type", value: "", isEditing: false, status: "Pending", isDropdown: true,
    options: ["HOTEL", "RESTAURANT", "CAFE", "CLOUD_KITCHEN", "FOOD_COURT", "STREET_FOOD", "BAKERY"]
  },
  {
    key: "Address",
    value: {
      doorNo: "",
      street: "",
      city: "",
      state: "",
      pincode: "",
      landmark: "",
      latitude: "",
      longitude: ""
    },
    isEditing: false,
    status: "Pending",
    isMapPicker: true,
    showLocationButton: true
  },
  { key: "Contact Name", value: "", isEditing: false, status: "Pending" },
  { key: "Phone No.", value: "", isEditing: false, status: "Pending" },
  { key: "Email ID", value: "", isEditing: false, status: "Pending" },
  { key: "Aadhar Card No.", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "GST No.", value: "", isEditing: false, status: "Not Verified" },
  { key: "Company Pan card No.", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  {
    key: "Trade License",
    value: { startDate: "", endDate: "", licenseNumber: "" },
    document: null,
    isUpload: true,
    isEditing: false,
    status: "Not Uploaded"
  },
  {
    key: "FSSAI License",
    value: { startDate: "", endDate: "", licenseNumber: "" },
    document: null,
    isUpload: true,
    isEditing: false,
    status: "Not Uploaded"
  },
  {
    key: "Labour License",
    value: { startDate: "", endDate: "", licenseNumber: "" },
    document: null,
    isUpload: true,
    isEditing: false,
    status: "Not Uploaded"
  },
  {
    key: "Bank Details",
    value: {
      holderName: "",
      accountNumber: "",
      branchName: "",
      ifscCode: "",
      passbookFile: null,
      passbookServerFileName: ""
    },
    isEditing: false,
    status: "Pending",
    isBankDetails: true
  },
];

const Registration = ({ onNext }) => {
  const [vendorDetails, setVendorDetails] = useState(null);
  const [rows, setRows] = useState(initialRowsConfig);
  const [isEditMode, setIsEditMode] = useState(false);
  const fileInputRefs = useRef({});
  const nestedFileInputRefs = useRef({});
  const [loading, setLoading] = useState(false);
  const [currentVendorId, setCurrentVendorId] = useState(null);
  const tableContainerRef = useRef(null);
  const [editingField, setEditingField] = useState(null);
  const [isRegistrationComplete, setIsRegistrationComplete] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [editingSection, setEditingSection] = useState(null); // 'company', 'address', 'contact', 'licenses', 'bank'
  const [selectedAddress, setSelectedAddress] = useState({
    doorNo: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    latitude: "",
    longitude: ""
  });

  const getRowConfigForKey = (key) => initialRowsConfig.find(r => r.key === key) || { value: {} };
  const { showLoader, hideLoader } = useLoader();

  const isFieldEditable = (fieldKey) => {
    const editableFields = [
      "Company Name",
      "Position",
      "Vertical Type",
      "Address",
      "Contact Name",
      "Phone No.",
      "Email ID",
      "GST No.",
      "Aadhar Card No.",
      "Company Pan card No.",
      "Trade License",
      "FSSAI License",
      "Labour License",
      "Bank Details"
    ];

    if (isRegistrationComplete) {
      return editableFields.includes(fieldKey);
    }
    return true;
  };
  // Add this with your other useState declarations (around line 50-60)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Add this useEffect with your other useEffects
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // ==================== GET VENDOR DETAILS ====================
  const getVendorDetails = useCallback(async (vendorIdToFetch) => {
    if (!vendorIdToFetch) {
      setVendorDetails(null);
      return;
    }

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/api/vendors/${vendorIdToFetch}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (!response.ok) {
        if (response.status === 404) {
          localStorage.removeItem("vendorId");
          setCurrentVendorId(null);
          setIsRegistrationComplete(false);
          setVendorDetails(null);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const fetchedVendorDetails = await response.json();

      setVendorDetails(fetchedVendorDetails);
      setCurrentVendorId(vendorIdToFetch);
      setIsRegistrationComplete(true);
      mapAndSetRowsFromVendorDetails(fetchedVendorDetails);
    } catch (error) {
      console.error("❌ Failed to fetch vendor details:", error.message);
      setVendorDetails(null);
      setCurrentVendorId(null);
      setIsRegistrationComplete(false);
    }
  }, []);

  // ==================== MAP API DATA TO ROWS ====================
  const mapAndSetRowsFromVendorDetails = useCallback((details) => {
    if (!details) {
      setRows(initialRowsConfig);
      return;
    }


    const updatedRows = initialRowsConfig.map(rowConfig => {
      const newRow = { ...rowConfig, document: rowConfig.isUpload ? null : undefined, isEditing: false };

      switch (rowConfig.key) {
        case "Contact Name":
          newRow.value = details.ownerName || "";
          newRow.status = details.ownerName ? "Provided" : "Pending";
          break;
        case "Company Name":
          newRow.value = details.registeredName || "";
          newRow.status = details.registeredName ? "Provided" : "Pending";
          break;
        case "Position":
          newRow.value = details.position || "";
          newRow.status = details.position ? "Provided" : "Pending";
          break;
        case "Vertical Type":
          newRow.value = details.type || "";
          newRow.status = details.type ? "Provided" : "Pending";
          break;
        case "Business Vertical":
          newRow.value = details.businessVertical || "FOOD_AND_BEVERAGES";
          newRow.status = "Provided";
          break;
        case "Phone No.":
          newRow.value = details.mobileNumber || "";
          newRow.status = details.mobileNumber ? "Provided" : "Pending";
          break;
        case "Email ID":
          newRow.value = details.email || "";
          newRow.status = details.email ? "Provided" : "Pending";
          break;
        case "Address":
          newRow.value = {
            doorNo: details.doorNumber || "",
            street: details.addressLine || "",
            city: details.city || "",
            state: details.state || "",
            pincode: details.pincode ? String(details.pincode) : "",
            landmark: details.landMark || "",
            latitude: details.latitude || "",
            longitude: details.longitude || ""
          };
          newRow.status = (details.doorNumber || details.addressLine) ? "Provided" : "Pending";
          break;
        case "Aadhar Card No.":
          newRow.value = details.aadharNumber || "";
          newRow.status = details.aadharNumber ? "Provided" : "Not Uploaded";
          break;
        case "Company Pan card No.":
          newRow.value = details.panCardNumber || "";
          newRow.status = details.panCardNumber ? "Provided" : "Not Uploaded";
          break;
        case "Trade License":
          newRow.value = {
            startDate: details.tradeLicenseStartDate || "",
            endDate: details.tradeLicenseEndDate || "",
            licenseNumber: details.tradeLicenseNumber || ""
          };
          newRow.status = details.tradeLicenseNumber ? "Provided" : "Not Uploaded";
          break;
        case "FSSAI License":
          newRow.value = {
            startDate: details.fssaiStartDate || "",
            endDate: details.fssaiEndDate || "",
            licenseNumber: details.fssaiLicenseNumber || ""
          };
          newRow.status = details.fssaiLicenseNumber ? "Provided" : "Not Uploaded";
          break;
        case "Labour License":
          newRow.value = {
            startDate: details.labourStartDate || "",
            endDate: details.labourEndDate || "",
            licenseNumber: details.labourLicenseNumber || ""
          };
          newRow.status = details.labourLicenseNumber ? "Provided" : "Not Uploaded";
          break;
        case "GST No.":
          newRow.value = details.gstNumber || "";
          newRow.status = details.gstNumber ? "Provided" : "Not Verified";
          break;
        case "Bank Details":
          newRow.value = {
            holderName: details.holderName || "",
            accountNumber: details.accountNumber || "",
            branchName: details.branchName || "",
            ifscCode: details.ifscCode || "",
            passbookFile: null,
            passbookServerFileName: details.passbook ? "Passbook" : ""
          };
          const hasTextData = newRow.value.holderName || newRow.value.accountNumber;
          newRow.status = (hasTextData || newRow.value.passbookServerFileName) ? "Provided" : "Pending";
          break;
        default:
          newRow.value = rowConfig.value;
      }
      return newRow;
    });
    setRows(updatedRows);
  }, []);

  // ==================== INITIAL LOAD ====================
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");

    if (storedVendorId) {
      getVendorDetails(storedVendorId);
    } else {
      setCurrentVendorId(null);
      setIsRegistrationComplete(false);
    }
  }, [getVendorDetails]);

  // ==================== HANDLE EDIT ====================
  const handleEdit = (index) => {
    if (!isFieldEditable(rows[index].key)) return;

    setRows(prevRows => prevRows.map((r, i) => ({
      ...r,
      isEditing: i === index
    })));
    setEditingField(rows[index].key);
    setIsEditMode(true);
  };

  const handleSave = (index) => {
    setRows(prevRows => prevRows.map((r, i) =>
      i === index ? { ...r, isEditing: false } : r
    ));
  };

  // ==================== UPDATE SINGLE FIELD ====================
  const handleUpdateField = async () => {
    if (!editingField) return;

    const editingRowIndex = rows.findIndex(r => r.key === editingField);
    if (editingRowIndex === -1) return;

    const editingRow = rows[editingRowIndex];

    try {
      showLoader();
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");

      if (!vendorId || !token) {
        alert("Vendor ID or Auth Token missing");
        return;
      }

      let updateData = { vendorId: vendorId };

      if (editingField === "Address") {
        updateData = {
          doorNumber: editingRow.value.doorNo || null,
          addressLine: editingRow.value.street || null,
          city: editingRow.value.city || null,
          state: editingRow.value.state || null,
          pincode: editingRow.value.pincode ? parseInt(editingRow.value.pincode, 10) : null,
          landMark: editingRow.value.landmark || null,
          latitude: editingRow.value.latitude || selectedAddress?.latitude || 0,
          longitude: editingRow.value.longitude || selectedAddress?.longitude || 0,
          vendorId: vendorId
        };
      } else if (editingField === "Bank Details") {
        updateData = {
          holderName: editingRow.value.holderName || null,
          accountNumber: editingRow.value.accountNumber || null,
          branchName: editingRow.value.branchName || null,
          ifscCode: editingRow.value.ifscCode || null,
          vendorId: vendorId
        };
      } else {
        updateData = {
          [getApiFieldName(editingField)]: editingRow.value || null,
          vendorId: vendorId
        };
      }

      const formData = new FormData();
      formData.append(
        "vendorData",
        new Blob([JSON.stringify(updateData)], { type: "application/json" })
      );

      if (editingField === "Bank Details" && editingRow.value.passbookFile instanceof File) {
        formData.append("passbook", editingRow.value.passbookFile);
      }

      const docKeys = [
        { rowKey: "Aadhar Card No.", formKey: "aadharPhoto" },
        { rowKey: "Company Pan card No.", formKey: "panCard" },
        { rowKey: "Trade License", formKey: "tradeLicense" },
        { rowKey: "FSSAI License", formKey: "fssaiLicense" },
        { rowKey: "Labour License", formKey: "labourLicense" },
      ];

      docKeys.forEach(({ rowKey, formKey }) => {
        const row = rows.find(r => r.key === rowKey);
        if (row && row.document instanceof File) {
          formData.append(formKey, row.document);
        }
      });

      const apiUrl = `https://backend.maamaas.com/food/api/vendors/edit/${vendorId}`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Authorization": `Bearer ${token}` },
        body: formData
      });


      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      setRows(prevRows =>
        prevRows.map(row =>
          row.key === editingField
            ? { ...row, status: "Provided", isEditing: false }
            : row
        )
      );

      setEditingField(null);
      setIsEditMode(false);
      await getVendorDetails(vendorId);

      alert(`✅ ${editingField} updated successfully!`);
    } catch (error) {
      console.error("❌ Error updating field:", error);
    } finally {
      hideLoader();
    }
  };

  // ==================== GET API FIELD NAME ====================
  const getApiFieldName = (fieldKey) => {
    const mapping = {
      "Contact Name": "ownerName",
      "Company Name": "registeredName",
      "Vertical Type": "type",
      "Phone No.": "mobileNumber",
      "Email ID": "email",
      "GST No.": "gstNumber",
      "Aadhar Card No.": "aadharNumber",
      "Company Pan card No.": "panCardNumber"
    };
    return mapping[fieldKey] || fieldKey.toLowerCase().replace(/\s+/g, '');
  };

  // ==================== HANDLE CONFIRM LOCATION ====================
  const handleConfirmLocation = async () => {
    if (!selectedAddress.latitude || !selectedAddress.longitude) return;


    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${selectedAddress.latitude}&lon=${selectedAddress.longitude}`
      );
      const data = await response.json();
      const address = data.address || {};

      const updatedAddress = {
        doorNo: address.house_number || selectedAddress.doorNo,
        street: address.road || selectedAddress.street,
        city: address.city || address.town || address.village || selectedAddress.city,
        state: address.state || selectedAddress.state,
        pincode: address.postcode || selectedAddress.pincode,
        landmark: address.neighbourhood || address.suburb || selectedAddress.landmark,
        latitude: selectedAddress.latitude,
        longitude: selectedAddress.longitude
      };

      setRows(prevRows =>
        prevRows.map(row =>
          row.key === "Address"
            ? { ...row, value: updatedAddress, isEditing: true, status: "Provided" }
            : row
        )
      );

      setEditingField("Address");
      setShowMap(false);
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  // ==================== FILE HANDLERS ====================
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    setRows(prevRows => prevRows.map((row, i) => {
      if (i === index) {
        return { ...row, document: file, status: "Uploaded" };
      }
      return row;
    }));
    e.target.value = "";
  };

  const handleNestedFileChange = (e, rowIndex, fileFieldKeyInObject) => {
    const file = e.target.files[0] || null;

    setRows(prevRows => prevRows.map((row, i) => {
      if (i === rowIndex) {
        const updatedValue = { ...row.value, [fileFieldKeyInObject]: file };
        if (file && fileFieldKeyInObject === 'passbookFile') {
          updatedValue.passbookServerFileName = "";
        }
        return { ...row, value: updatedValue };
      }
      return row;
    }));
    if (e.target) e.target.value = null;
  };

  const handleUploadClick = (index) => {
    fileInputRefs.current[index]?.click();
  };

  const handleNestedUploadTrigger = (rowIndex, fileFieldKeyInObject) => {
    const refKey = `${rowIndex}_${fileFieldKeyInObject}`;
    if (nestedFileInputRefs.current[refKey]) {
      nestedFileInputRefs.current[refKey].click();
    }
  };

  const getValue = (key) => rows.find((r) => r.key === key)?.value;
  const getDocumentFile = (key) => {
    const row = rows.find((r) => r.key === key);
    return (row && row.document instanceof File) ? row.document : null;
  };

  // ==================== CHECK IF VENDOR EXISTS ====================
  const checkIfVendorExists = async (vendorId) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 404) {
        // Vendor not found - first time registration
        return false;
      }

      if (response.ok) {
        // Vendor exists - already registered
        return true;
      }

      return false;
    } catch (error) {
      console.error("Error checking vendor:", error);
      return false;
    }
  };

  // ==================== MAIN SUBMIT HANDLER ====================
  // ==================== MAIN SUBMIT HANDLER ====================
  // ==================== MAIN SUBMIT HANDLER ====================
  // ==================== MAIN SUBMIT HANDLER ====================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authToken");
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const storedVendorId = userData.vendorId || localStorage.getItem("vendorId");
    const customerId = userData.customerId || localStorage.getItem("customerId");

    if (!storedVendorId) {
      console.error("❌ No vendorId found");
      alert("Vendor ID is missing. Please log in again.");
      return;
    }

    setLoading(true);
    showLoader();

    try {
      // 🔥 CHECK IF VENDOR EXISTS FIRST
      const vendorExists = await checkIfVendorExists(storedVendorId);

      const addressValue = getValue("Address") || {};
      const bankDetailsValue = getValue("Bank Details") || {};

      // Build fullAddress
      const fullAddress = [
        addressValue.doorNo,
        addressValue.street,
        addressValue.landmark,
        addressValue.city,
        addressValue.state,
        addressValue.pincode
      ].filter(Boolean).join(", ");

      // Get order types
      let orderTypesList = [];
      const bannerData = localStorage.getItem("bannerData");
      if (bannerData) {
        try {
          const parsedBanner = JSON.parse(bannerData);
          if (parsedBanner.orderTypes && parsedBanner.orderTypes.length > 0) {
            orderTypesList = parsedBanner.orderTypes;
          }
        } catch (e) { }
      }

      if (orderTypesList.length === 0) {
        orderTypesList = ["DINE_IN", "TAKEAWAY"];
      }

      let vendorData = {
        customerId: customerId || null,
        ownerName: getValue("Contact Name") || null,
        registeredName: getValue("Company Name") || null,
        type: getValue("Vertical Type") ? getValue("Vertical Type").toUpperCase() : null,
        vendorType: "Restaurant",
        position: getValue("Position") || null,
        businessVertical: "FOOD_AND_BEVERAGES",
        mobileNumber: getValue("Phone No.") || null,
        email: getValue("Email ID") || null,
        doorNumber: addressValue.doorNo || null,
        addressLine: addressValue.street || null,
        city: addressValue.city || null,
        state: addressValue.state || null,
        pincode: addressValue.pincode ? parseInt(addressValue.pincode, 10) : null,
        landMark: addressValue.landmark || null,
        latitude: addressValue.latitude || 0,
        longitude: addressValue.longitude || 0,
        fullAddress: fullAddress || null,
        aadharNumber: getValue("Aadhar Card No.") || null,
        panCardNumber: getValue("Company Pan card No.") || null,
        gstNumber: getValue("GST No.") || null,
        tradeLicenseStartDate: getValue("Trade License")?.startDate || null,
        tradeLicenseEndDate: getValue("Trade License")?.endDate || null,
        tradeLicenseNumber: getValue("Trade License")?.licenseNumber || null,
        fssaiStartDate: getValue("FSSAI License")?.startDate || null,
        fssaiEndDate: getValue("FSSAI License")?.endDate || null,
        fssaiLicenseNumber: getValue("FSSAI License")?.licenseNumber || null,
        labourStartDate: getValue("Labour License")?.startDate || null,
        labourEndDate: getValue("Labour License")?.endDate || null,
        labourLicenseNumber: getValue("Labour License")?.licenseNumber || null,
        holderName: bankDetailsValue.holderName || null,
        accountNumber: bankDetailsValue.accountNumber || null,
        branchName: bankDetailsValue.branchName || null,
        ifscCode: bankDetailsValue.ifscCode || null,
        orderTypes: orderTypesList,
        vendorId: parseInt(storedVendorId),
      };


      const formDataToSend = new FormData();
      formDataToSend.append(
        "vendorData",
        new Blob([JSON.stringify(vendorData)], { type: "application/json" })
      );

      if (bankDetailsValue.passbookFile instanceof File) {
        formDataToSend.append("passbook", bankDetailsValue.passbookFile);
      }

      const docKeys = [
        { rowKey: "Aadhar Card No.", formKey: "aadharPhoto" },
        { rowKey: "Company Pan card No.", formKey: "panCard" },
        { rowKey: "Trade License", formKey: "tradeLicense" },
        { rowKey: "FSSAI License", formKey: "fssaiLicense" },
        { rowKey: "Labour License", formKey: "labourLicense" },
      ];

      docKeys.forEach(({ rowKey, formKey }) => {
        const file = getDocumentFile(rowKey);
        if (file instanceof File) {
          formDataToSend.append(formKey, file);
        }
      });

      // 🔥 DECIDE WHICH API TO USE BASED ON VENDOR EXISTENCE
      let apiUrl;
      let method;

      if (vendorExists) {
        // VENDOR EXISTS - Use PUT API (update)
        apiUrl = `https://backend.maamaas.com/food/api/vendors/edit/${storedVendorId}`;
        method = "PUT";
      } else {
        // FIRST TIME - Use POST API (create)
        apiUrl = `https://backend.maamaas.com/food/api/vendors/${storedVendorId}`;
        method = "POST";
      }


      const response = await fetch(apiUrl, {
        method: method,
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });


      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Backend error:", errorText);
        alert(`Submission Failed: ${errorText}`);
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.json();

      setIsRegistrationComplete(true);
      alert(vendorExists ? "Vendor updated successfully!" : "Vendor registered successfully!");

      // Refresh vendor details
      await getVendorDetails(storedVendorId);

    } catch (error) {
      console.error("❌ Submission error:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  // Handle section save
  const handleSectionSave = async (section) => {
    let fieldToUpdate = '';

    switch (section) {
      case 'company':
        fieldToUpdate = 'Company Name';
        break;
      case 'address':
        fieldToUpdate = 'Address';
        break;
      case 'contact':
        fieldToUpdate = 'Contact Name';
        break;
      case 'licenses':
        // For licenses, we need to update multiple fields
        // You can call handleUpdateField for each or create a batch update
        fieldToUpdate = 'GST No.';
        break;
      case 'bank':
        fieldToUpdate = 'Bank Details';
        break;
      default:
        return;
    }

    setEditingField(fieldToUpdate);
    await handleUpdateField();
    setEditingSection(null);
  };

  const handleCancelEdit = () => {
    setRows(prevRows => prevRows.map(r => ({ ...r, isEditing: false })));
    setEditingField(null);
    setIsEditMode(false);
    if (currentVendorId) {
      getVendorDetails(currentVendorId);
    }
  };

  const renderSectionHeading = (title, index) => {
    return (
      <tr key={`section-${index}`}>
        <td colSpan="5" style={sectionHeadingStyle}>
          <strong>{title}</strong>
        </td>
      </tr>
    );
  };

  // Add these style objects
  const mobileCardStyle = {
    background: "white",
    borderRadius: "14px",
    marginBottom: "16px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    border: "1px solid #eee",
    overflow: "hidden"
  };

  const mobileCardHeaderStyle = {
    background: "#fef3e8",
    padding: "13px 16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderBottom: "1px solid #ffe5cc"
  };

  const mobileCardBodyStyle = {
    padding: "16px"
  };

  const mobileFieldRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
    paddingBottom: "8px",
    borderBottom: "1px solid #f0f0f0"
  };

  const mobileLabelStyle = {
    fontSize: "13px",
    fontWeight: "600",
    color: "#666",
    minWidth: "110px"
  };

  const mobileValueStyle = {
    flex: 1,
    textAlign: "right"
  };

  const mobileInputStyle = {
    width: "60%",
    padding: "8px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "13px"
  };

  const mobileSaveBtn = {
    background: "#e66d33",
    color: "white",
    border: "none",
    padding: "5px 12px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "bold",
    cursor: "pointer"
  };

  const mobileUploadBtn = {
    background: "#5bc0de",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    cursor: "pointer"
  };

  const mobileLocationBtn = {
    background: "#4CAF50",
    color: "white",
    border: "none",
    padding: "8px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    width: "100%",
    marginTop: "8px"
  };

  const mobileSubmitBtn = {
    background: "#e66d33",
    color: "white",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
    marginTop: "8px"
  };

  const mobileDocRowStyle = {
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: "1px solid #f0f0f0"
  };

  const getStatusBadgeStyle = (status) => {
    const color = ['Provided', 'Uploaded', 'Verified'].includes(status) ? '#28a745' :
      ['Pending', 'Not Uploaded', 'Not Verified'].includes(status) ? '#ffc107' : '#6c757d';
    return {
      background: color + '20',
      color: color,
      padding: "3px 8px",
      borderRadius: "12px",
      fontSize: "10px",
      fontWeight: "600"
    };
  };

  // Add this helper function for mobile field rendering
  const renderMobileField = (row, idx) => {
    if (row.isDropdown) {
      return (
        <select value={row.value} onChange={(e) => {
          const newRows = [...rows];
          newRows[idx].value = e.target.value;
          setRows(newRows);
        }} style={mobileInputStyle}>
          {row.options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      );
    }
    return (
      <input type="text" value={row.value || ''} onChange={(e) => {
        const newRows = [...rows];
        newRows[idx].value = e.target.value;
        setRows(newRows);
      }} style={mobileInputStyle} readOnly={isRegistrationComplete} />
    );
  };

  // Add this function to handle bank update
  const handleUpdateFieldBank = async () => {
    setEditingField("Bank Details");
    await handleUpdateField();
  };

  return (
    <>
      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            scrollbar-width: thin;
            -ms-overflow-style: none;
          }
        `}
      </style>
      {windowWidth <= 500 ? (
        // MOBILE CARD VIEW - Flutter style
        <div className="mobile-registration-cards" style={{ padding: "12px 0px" }}>
          <form onSubmit={handleSubmit}>
            {/* SECTION 1: COMPANY DETAILS */}
            <div style={mobileCardStyle}>
              <div style={mobileCardHeaderStyle}>
                <h4 style={{ margin: 0, flex: 1, fontSize: "14px", fontWeight: "700" }}>COMPANY DETAILS</h4>
                {/* {isRegistrationComplete && (
                  <>
                    {editingSection === 'company' ? (
                      <button type="button" style={mobileSaveBtn} onClick={() => handleSectionSave('company')}>
                        Save 
                      </button>
                    ) : (
                      <button type="button" style={mobileEditBtn} onClick={() => setEditingSection('company')}>
                        Edit 
                      </button>
                    )}
                  </>
                )} */}
              </div>
              <div style={mobileCardBodyStyle}>
                {rows.slice(0, 4).map((row, idx) => {
                  const actualIndex = idx;
                  const isEditing = editingSection === 'company';
                  return (
                    <div key={row.key} style={mobileFieldRowStyle}>
                      <span style={mobileLabelStyle}>{row.key}</span>
                      <div style={{ flex: 1, textAlign: "right" }}>
                        {isEditing ? (
                          row.isDropdown ? (
                            <select
                              value={row.value || ""}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[actualIndex].value = e.target.value;
                                setRows(newRows);
                              }}
                              style={mobileInputStyle}
                            >
                              {row.options.map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type="text"
                              value={row.value || ""}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[actualIndex].value = e.target.value;
                                setRows(newRows);
                              }}
                              style={mobileInputStyle}
                            />
                          )
                        ) : (
                          <span style={{ fontSize: "13px", color: "#333" }}>
                            {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* SECTION 2: ADDRESS & LOCATION */}
            <div style={mobileCardStyle}>
              <div style={mobileCardHeaderStyle}>
                <h4 style={{ margin: 0, flex: 1, fontSize: "14px", fontWeight: "700" }}>ADDRESS & LOCATION</h4>
                {isRegistrationComplete && (
                  <>
                    {editingSection === 'address' ? (
                      <button type="button" style={mobileSaveBtn} onClick={() => handleSectionSave('address')}>
                        Save
                      </button>
                    ) : (
                      <button type="button" style={mobileEditBtn} onClick={() => setEditingSection('address')}>
                        Edit
                      </button>
                    )}
                  </>
                )}
              </div>
              <div style={mobileCardBodyStyle}>
                {Object.entries(rows[4].value).map(([k, v]) => {
                  if (k === 'latitude' || k === 'longitude') return null;
                  const isEditing = editingSection === 'address';
                  return (
                    <div key={k} style={mobileFieldRowStyle}>
                      <span style={mobileLabelStyle}>{k.replace(/([A-Z])/g, ' $1').trim()}</span>
                      {isEditing ? (
                        <input
                          type="text"
                          value={v || ''}
                          onChange={(e) => {
                            const newRows = [...rows];
                            newRows[4].value[k] = e.target.value;
                            setRows(newRows);
                          }}
                          style={mobileInputStyle}
                        />
                      ) : (
                        <span style={{ fontSize: "13px", color: "#333" }}>
                          {v || <em style={{ color: "#999" }}>Not specified</em>}
                        </span>
                      )}
                    </div>
                  );
                })}
                {rows[4].showLocationButton && editingSection === 'address' && (
                  <button type="button" style={mobileLocationBtnSmall} onClick={() => setShowMap(true)}>
                    📍 Add Location from Map
                  </button>
                )}
              </div>
            </div>

            {/* SECTION 3: CONTACT DETAILS */}
            <div style={mobileCardStyle}>
              <div style={mobileCardHeaderStyle}>
                <h4 style={{ margin: 0, flex: 1, fontSize: "14px", fontWeight: "700" }}>CONTACT DETAILS</h4>
                {isRegistrationComplete && (
                  <>
                    {editingSection === 'contact' ? (
                      <button type="button" style={mobileSaveBtn} onClick={() => handleSectionSave('contact')}>
                        Save
                      </button>
                    ) : (
                      <button type="button" style={mobileEditBtn} onClick={() => setEditingSection('contact')}>
                        Edit
                      </button>
                    )}
                  </>
                )}
              </div>
              <div style={mobileCardBodyStyle}>
                {rows.slice(5, 8).map((row, idx) => {
                  const actualIndex = 5 + idx;
                  const isEditing = editingSection === 'contact';
                  return (
                    <div key={row.key} style={mobileFieldRowStyle}>
                      <span style={mobileLabelStyle}>{row.key}</span>
                      {isEditing ? (
                        <input
                          type={row.key === "Phone No." ? "tel" : "text"}
                          value={row.value || ""}
                          onChange={(e) => {
                            const newRows = [...rows];
                            newRows[actualIndex].value = e.target.value;
                            setRows(newRows);
                          }}
                          style={mobileInputStyle}
                        />
                      ) : (
                        <span style={{ fontSize: "13px", color: "#333" }}>
                          {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* SECTION 4: LICENSES & DOCUMENTS */}
            <div style={mobileCardStyle}>
              <div style={mobileCardHeaderStyle}>
                <h4 style={{ margin: 0, flex: 1, fontSize: "14px", fontWeight: "700" }}>LICENSES & DOCUMENTS</h4>
                {isRegistrationComplete && (
                  <>
                    {editingSection === 'licenses' ? (
                      <button type="button" style={mobileSaveBtn} onClick={() => handleSectionSave('licenses')}>
                        Save
                      </button>
                    ) : (
                      <button type="button" style={mobileEditBtn} onClick={() => setEditingSection('licenses')}>
                        Edit
                      </button>
                    )}
                  </>
                )}
              </div>
              <div style={mobileCardBodyStyle}>
                {/* Aadhar Card No. */}
                {(() => {
                  const row = rows[8];
                  const actualIndex = 8;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            value={row.value || ""}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value = e.target.value;
                              setRows(newRows);
                            }}
                            style={{ ...mobileInputStyle, width: '100%', marginBottom: '8px' }}
                            placeholder="Aadhar Number"
                          />
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button type="button" style={mobileUploadBtnSmall} onClick={() => fileInputRefs.current[actualIndex]?.click()}>
                              {row.document ? 'Change File' : 'Upload File'}
                            </button>
                            <input type="file" style={{ display: 'none' }} ref={el => fileInputRefs.current[actualIndex] = el} onChange={(e) => handleFileChange(e, actualIndex)} />
                            <span style={{ fontSize: '11px', color: '#666' }}>{row.document?.name || 'No file'}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontSize: "13px", color: "#333" }}>
                              {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                            </span>
                          </div>
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            {row.document?.name || (row.document ? 'File uploaded' : 'No file uploaded')}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })()}

                {/* GST No. */}
                {(() => {
                  const row = rows[9];
                  const actualIndex = 9;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <input
                          type="text"
                          value={row.value || ""}
                          onChange={(e) => {
                            const newRows = [...rows];
                            newRows[actualIndex].value = e.target.value;
                            setRows(newRows);
                          }}
                          style={mobileInputStyle}
                        />
                      ) : (
                        <span style={{ fontSize: "13px", color: "#333" }}>
                          {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                        </span>
                      )}
                    </div>
                  );
                })()}

                {/* Company Pan card No. */}
                {(() => {
                  const row = rows[10];
                  const actualIndex = 10;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            value={row.value || ""}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value = e.target.value;
                              setRows(newRows);
                            }}
                            style={{ ...mobileInputStyle, width: '100%', marginBottom: '8px' }}
                            placeholder="Pan Card Number"
                          />
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button type="button" style={mobileUploadBtnSmall} onClick={() => fileInputRefs.current[actualIndex]?.click()}>
                              {row.document ? 'Change File' : 'Upload File'}
                            </button>
                            <input type="file" style={{ display: 'none' }} ref={el => fileInputRefs.current[actualIndex] = el} onChange={(e) => handleFileChange(e, actualIndex)} />
                            <span style={{ fontSize: '11px', color: '#666' }}>{row.document?.name || 'No file'}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontSize: "13px", color: "#333" }}>
                              {row.value || <em style={{ color: "#999" }}>Not specified</em>}
                            </span>
                          </div>
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            {row.document?.name || (row.document ? 'File uploaded' : 'No file uploaded')}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })()}

                {/* Trade License */}
                {(() => {
                  const row = rows[11];
                  const actualIndex = 11;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <>
                          <input type="text" placeholder="License Number" value={row.value.licenseNumber || ''} onChange={(e) => {
                            const newRows = [...rows];
                            newRows[actualIndex].value.licenseNumber = e.target.value;
                            setRows(newRows);
                          }} style={{ ...mobileInputStyle, width: '100%', marginBottom: '8px' }} />
                          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <input type="date" placeholder="Start Date" value={row.value.startDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.startDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                            <input type="date" placeholder="End Date" value={row.value.endDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.endDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                          </div>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button type="button" style={mobileUploadBtnSmall} onClick={() => fileInputRefs.current[actualIndex]?.click()}>
                              {row.document ? 'Change File' : 'Upload File'}
                            </button>
                            <input type="file" style={{ display: 'none' }} ref={el => fileInputRefs.current[actualIndex] = el} onChange={(e) => handleFileChange(e, actualIndex)} />
                            <span style={{ fontSize: '11px', color: '#666' }}>{row.document?.name || 'No file'}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: '8px' }}>
                            <div><strong>Number:</strong> {row.value.licenseNumber || 'N/A'}</div>
                            <div><strong>Start:</strong> {row.value.startDate || 'N/A'}</div>
                            <div><strong>End:</strong> {row.value.endDate || 'N/A'}</div>
                          </div>
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            {row.document?.name || (row.document ? 'File uploaded' : 'No file uploaded')}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })()}

                {/* FSSAI License */}
                {(() => {
                  const row = rows[12];
                  const actualIndex = 12;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <>
                          <input type="text" placeholder="License Number" value={row.value.licenseNumber || ''} onChange={(e) => {
                            const newRows = [...rows];
                            newRows[actualIndex].value.licenseNumber = e.target.value;
                            setRows(newRows);
                          }} style={{ ...mobileInputStyle, width: '100%', marginBottom: '8px' }} />
                          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <input type="date" placeholder="Start Date" value={row.value.startDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.startDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                            <input type="date" placeholder="End Date" value={row.value.endDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.endDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                          </div>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button type="button" style={mobileUploadBtnSmall} onClick={() => fileInputRefs.current[actualIndex]?.click()}>
                              {row.document ? 'Change File' : 'Upload File'}
                            </button>
                            <input type="file" style={{ display: 'none' }} ref={el => fileInputRefs.current[actualIndex] = el} onChange={(e) => handleFileChange(e, actualIndex)} />
                            <span style={{ fontSize: '11px', color: '#666' }}>{row.document?.name || 'No file'}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: '8px' }}>
                            <div><strong>Number:</strong> {row.value.licenseNumber || 'N/A'}</div>
                            <div><strong>Start:</strong> {row.value.startDate || 'N/A'}</div>
                            <div><strong>End:</strong> {row.value.endDate || 'N/A'}</div>
                          </div>
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            {row.document?.name || (row.document ? 'File uploaded' : 'No file uploaded')}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })()}

                {/* Labour License */}
                {(() => {
                  const row = rows[13];
                  const actualIndex = 13;
                  const isEditing = editingSection === 'licenses';
                  return (
                    <div key={row.key} style={mobileDocRowStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={mobileLabelStyle}>{row.key}</span>
                        <span style={getStatusBadgeStyle(row.status)}>{row.status}</span>
                      </div>
                      {isEditing ? (
                        <>
                          <input type="text" placeholder="License Number" value={row.value.licenseNumber || ''} onChange={(e) => {
                            const newRows = [...rows];
                            newRows[actualIndex].value.licenseNumber = e.target.value;
                            setRows(newRows);
                          }} style={{ ...mobileInputStyle, width: '100%', marginBottom: '8px' }} />
                          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <input type="date" placeholder="Start Date" value={row.value.startDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.startDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                            <input type="date" placeholder="End Date" value={row.value.endDate || ''} onChange={(e) => {
                              const newRows = [...rows];
                              newRows[actualIndex].value.endDate = e.target.value;
                              setRows(newRows);
                            }} style={mobileInputStyle} />
                          </div>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button type="button" style={mobileUploadBtnSmall} onClick={() => fileInputRefs.current[actualIndex]?.click()}>
                              {row.document ? 'Change File' : 'Upload File'}
                            </button>
                            <input type="file" style={{ display: 'none' }} ref={el => fileInputRefs.current[actualIndex] = el} onChange={(e) => handleFileChange(e, actualIndex)} />
                            <span style={{ fontSize: '11px', color: '#666' }}>{row.document?.name || 'No file'}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: '8px' }}>
                            <div><strong>Number:</strong> {row.value.licenseNumber || 'N/A'}</div>
                            <div><strong>Start:</strong> {row.value.startDate || 'N/A'}</div>
                            <div><strong>End:</strong> {row.value.endDate || 'N/A'}</div>
                          </div>
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            {row.document?.name || (row.document ? 'File uploaded' : 'No file uploaded')}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* SECTION 5: BANK DETAILS */}
            <div style={mobileCardStyle}>
              <div style={mobileCardHeaderStyle}>
                <h4 style={{ margin: 0, flex: 1, fontSize: "14px", fontWeight: "700" }}>BANK DETAILS</h4>
                {isRegistrationComplete && (
                  <>
                    {editingSection === 'bank' ? (
                      <button type="button" style={mobileSaveBtn} onClick={() => handleSectionSave('bank')}>
                        Save
                      </button>
                    ) : (
                      <button type="button" style={mobileEditBtn} onClick={() => setEditingSection('bank')}>
                        Edit
                      </button>
                    )}
                  </>
                )}
              </div>
              <div style={mobileCardBodyStyle}>
                {Object.entries(rows[14].value).map(([k, v]) => {
                  if (k === 'passbookFile' || k === 'passbookServerFileName') return null;
                  const isEditing = editingSection === 'bank';
                  return (
                    <div key={k} style={mobileFieldRowStyle}>
                      <span style={mobileLabelStyle}>{k.replace(/([A-Z])/g, ' $1').trim()}</span>
                      {isEditing ? (
                        <input
                          type="text"
                          value={v || ''}
                          onChange={(e) => {
                            const newRows = [...rows];
                            newRows[14].value[k] = e.target.value;
                            setRows(newRows);
                          }}
                          style={mobileInputStyle}
                        />
                      ) : (
                        <span style={{ fontSize: "13px", color: "#333" }}>
                          {v || <em style={{ color: "#999" }}>Not specified</em>}
                        </span>
                      )}
                    </div>
                  );
                })}
                <div style={mobileFieldRowStyle}>
                  <span style={mobileLabelStyle}>Passbook</span>
                  {editingSection === 'bank' ? (
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                      <button type="button" style={mobileUploadBtnSmall} onClick={() => {
                        const refKey = `14_passbookFile`;
                        if (nestedFileInputRefs.current[refKey]) {
                          nestedFileInputRefs.current[refKey].click();
                        }
                      }}>
                        {rows[14].value.passbookFile ? 'Change' : 'Upload'}
                      </button>
                      <input type="file" style={{ display: 'none' }} ref={el => nestedFileInputRefs.current['14_passbookFile'] = el} onChange={(e) => handleNestedFileChange(e, 14, 'passbookFile')} />
                      <span style={{ fontSize: '11px', color: '#666' }}>{rows[14].value.passbookFile?.name || rows[14].value.passbookServerFileName || 'No file'}</span>
                    </div>
                  ) : (
                    <span style={{ fontSize: "13px", color: "#333" }}>
                      {rows[14].value.passbookServerFileName ? '✓ Uploaded' : <em style={{ color: "#999" }}>Not uploaded</em>}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* SUBMIT BUTTON - Only shows when NOT in edit mode or for new registration */}
            {(!isRegistrationComplete || editingSection === null) && (
              <button type="submit" style={mobileSubmitBtn} disabled={loading}>
                {loading ? 'Submitting...' : (isRegistrationComplete ? 'Update Registration' : 'Submit Registration')}
              </button>
            )}
          </form>
        </div>
      ) : (
        <div className="scrooltable hide-scrollbar" style={{ marginTop: "0px", padding: "0px" }}>
          <form onSubmit={handleSubmit}>
            <div
              ref={tableContainerRef}
              style={{
                overflow: "auto",
                border: "1px solid rgba(221, 221, 221, 1)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}
              className="hide-scrollbar"
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "0",
                  tableLayout: "fixed"
                }}>
                <thead style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  backgroundColor: "#e66d33"
                }}>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: window.innerWidth < 1100 ? "120px" : "150px" }}>Field</th>
                    <th style={{ ...tableHeaderStyle, width: window.innerWidth < 1100 ? "250px" : "350px" }}>Value</th>
                    <th style={{ ...tableHeaderStyle, width: "150px" }}>Document</th>
                    <th style={{ ...tableHeaderStyle, width: "80px" }}>Status</th>
                    <th style={{ ...tableHeaderStyle, width: "80px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody style={{ overflowY: "auto" }}>
                  {sections.map((section, sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                      {renderSectionHeading(section.title, sectionIndex)}
                      {rows.slice(section.startIndex, sectionIndex < sections.length - 1
                        ? sections[sectionIndex + 1].startIndex
                        : rows.length).map((row, index) => {
                          const actualIndex = section.startIndex + index;
                          return (
                            <tr key={row.key} style={actualIndex % 2 === 0 ? evenRowStyle : oddRowStyle}>
                              <td style={tableCellStyle}>
                                <strong>{row.key}</strong>
                              </td>
                              <td style={{
                                ...tableCellStyle,
                                textAlign: "left",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                              }}>
                                {row.isEditing ? (
                                  row.key.includes("License") ? (
                                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                      <input
                                        type="text"
                                        value={row.value.licenseNumber || ""}
                                        onChange={(e) =>
                                          setRows((prevRows) =>
                                            prevRows.map((r, i) =>
                                              i === actualIndex ? { ...r, value: { ...r.value, licenseNumber: e.target.value } } : r
                                            )
                                          )
                                        }
                                        placeholder="License Number"
                                        style={inputStyle}
                                      />
                                      <input
                                        type="date"
                                        value={row.value.startDate || ""}
                                        onChange={(e) =>
                                          setRows((prevRows) =>
                                            prevRows.map((r, i) =>
                                              i === actualIndex ? { ...r, value: { ...r.value, startDate: e.target.value } } : r
                                            )
                                          )
                                        }
                                        style={inputStyle}
                                        placeholder="Start Date"
                                      />
                                      <input
                                        type="date"
                                        value={row.value.endDate || ""}
                                        onChange={(e) =>
                                          setRows((prevRows) =>
                                            prevRows.map((r, i) =>
                                              i === actualIndex ? { ...r, value: { ...r.value, endDate: e.target.value } } : r
                                            )
                                          )
                                        }
                                        style={inputStyle}
                                        placeholder="End Date"
                                      />
                                    </div>
                                  ) : row.isDropdown ? (
                                    <select
                                      value={row.value || ""}
                                      onChange={(e) =>
                                        setRows((prevRows) =>
                                          prevRows.map((r, i) =>
                                            i === actualIndex ? { ...r, value: e.target.value } : r
                                          )
                                        )
                                      }
                                      style={inputStyle}
                                    >
                                      <option value="">-- Select --</option>
                                      {row.options.map((opt) => (
                                        <option key={opt} value={opt}>
                                          {opt}
                                        </option>
                                      ))}
                                    </select>
                                  ) : row.key === "Address" || row.key === "Bank Details" ? (
                                    typeof row.value === "object" && row.value !== null ? (
                                      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                        {Object.entries(row.value).map(([k, v_val]) => {
                                          if (k === "passbookFile" || k === "passbookServerFileName") return null;
                                          const isLatLng = k === "latitude" || k === "longitude";

                                          return (
                                            <input
                                              key={k}
                                              type={k === "accountNumber" ? "number" : "text"}
                                              value={v_val || ""}
                                              onChange={(e) => {
                                                if (!isLatLng) {
                                                  setRows((prevRows) =>
                                                    prevRows.map((r, rowIndex) => {
                                                      if (rowIndex === actualIndex) {
                                                        const currentVal =
                                                          typeof r.value === "object" && r.value !== null
                                                            ? r.value
                                                            : getRowConfigForKey(row.key).value;
                                                        return {
                                                          ...r,
                                                          value: { ...currentVal, [k]: e.target.value },
                                                        };
                                                      }
                                                      return r;
                                                    })
                                                  );
                                                }
                                              }}
                                              style={{
                                                ...inputStyle,
                                                backgroundColor: isLatLng ? "#f5f5f5" : "#fff",
                                              }}
                                              placeholder={k
                                                .replace(/([A-Z])/g, " $1")
                                                .trim()
                                                .replace(/^\w/, (c) => c.toUpperCase())}
                                              readOnly={isLatLng}
                                            />
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <input type="text" value="Invalid data structure" disabled style={inputStyle} />
                                    )
                                  ) : (
                                    <input
                                      type={row.key === "Phone No." ? "tel" : "text"}
                                      value={row.value || ""}
                                      onChange={(e) =>
                                        setRows((prevRows) =>
                                          prevRows.map((r, i) =>
                                            i === actualIndex ? { ...r, value: e.target.value } : r
                                          )
                                        )
                                      }
                                      style={inputStyle}
                                      placeholder={`Enter ${row.key}`}
                                    />
                                  )
                                ) : (
                                  row.key === "Address" || row.key === "Bank Details" ? (
                                    typeof row.value === "object" &&
                                      row.value !== null &&
                                      Object.values(row.value).some(
                                        (val) =>
                                          (typeof val === "string" && val.trim() !== "") ||
                                          (typeof val === "object" && val !== null)
                                      ) ? (
                                      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                        {Object.entries(row.value).map(([k, v_val]) => {
                                          if (k === "passbookFile" || k === "passbookServerFileName") return null;
                                          if (
                                            v_val &&
                                            (typeof v_val === "string" || typeof v_val === "number")
                                          ) {
                                            return (
                                              <div key={k} style={{ fontSize: "0.9em" }}>
                                                <strong style={{ textTransform: "capitalize" }}>
                                                  {k.replace(/([A-Z])/g, " $1").trim()}:
                                                </strong>{" "}
                                                {String(v_val)}
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </div>
                                    ) : (
                                      <em>Not specified</em>
                                    )
                                  ) : row.key.includes("License") ? (
                                    row.value && typeof row.value === "object" ? (
                                      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                        <div><strong>License Number:</strong> {row.value.licenseNumber || "N/A"}</div>
                                        <div><strong>Start:</strong> {row.value.startDate || "N/A"}</div>
                                        <div><strong>End:</strong> {row.value.endDate || "N/A"}</div>
                                      </div>
                                    ) : (
                                      <em>Not specified</em>
                                    )
                                  ) : (
                                    <div style={{ wordBreak: "break-word" }}>
                                      {row.value || <em>Not specified</em>}
                                    </div>
                                  )
                                )}
                              </td>
                              <td style={tableCellStyle}>
                                {row.key === "Address" && row.showLocationButton ? (
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
                                    <button
                                      type="button"
                                      onClick={() => setShowMap(true)}
                                      style={locationButtonStyle}
                                    >
                                      📍 Add Location
                                    </button>
                                  </div>
                                ) : row.isUpload ? (
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
                                    <button type="button" style={buttonStyle} onClick={() => handleUploadClick(actualIndex)}>
                                      Upload File
                                    </button>
                                    <input
                                      type="file"
                                      style={{ display: "none" }}
                                      ref={(el) => { if (el) fileInputRefs.current[actualIndex] = el; }}
                                      onChange={(e) => handleFileChange(e, actualIndex)}
                                      accept="image/*,.pdf,.doc,.docx"
                                    />
                                    <div style={fileInfoStyle}>
                                      {row.document?.name ||
                                        (row.document &&
                                          typeof row.document === "object" &&
                                          !row.document.name
                                          ? "Server file present"
                                          : "")}
                                    </div>
                                  </div>
                                ) : row.key === "Bank Details" ? (
                                  (() => {
                                    let passbookDisplayStatus;
                                    let statusColor = "orange";

                                    if (row.value.passbookFile) {
                                      passbookDisplayStatus = "File Selected";
                                      statusColor = "#007bff";
                                    } else if (row.value.passbookServerFileName) {
                                      passbookDisplayStatus = "Provided";
                                      statusColor = "green";
                                    } else {
                                      passbookDisplayStatus = "Not Uploaded";
                                    }

                                    return (
                                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
                                        {row.isEditing ? (
                                          <>
                                            <button
                                              type="button"
                                              style={buttonStyle}
                                              onClick={() =>
                                                handleNestedUploadTrigger(actualIndex, "passbookFile")
                                              }
                                            >
                                              {row.value.passbookFile
                                                ? "Change Passbook"
                                                : row.value.passbookServerFileName
                                                  ? "Replace Passbook"
                                                  : "Upload Passbook"}
                                            </button>
                                            <input
                                              type="file"
                                              style={{ display: "none" }}
                                              ref={(el) =>
                                                (nestedFileInputRefs.current[`${actualIndex}_passbookFile`] = el)
                                              }
                                              onChange={(e) =>
                                                handleNestedFileChange(e, actualIndex, "passbookFile")
                                              }
                                              accept="image/*,.pdf,.doc,.docx"
                                            />
                                            <div style={fileInfoStyle}>
                                              {row.value.passbookFile?.name ||
                                                row.value.passbookServerFileName || (
                                                  <em>No passbook selected</em>
                                                )}
                                            </div>
                                          </>
                                        ) : (
                                          <div style={fileInfoStyle}>
                                            {row.value.passbookServerFileName ? (
                                              <span>✓ Passbook uploaded</span>
                                            ) : (
                                              <em>No passbook uploaded</em>
                                            )}
                                          </div>
                                        )}
                                        <div style={{ ...fileInfoStyle, color: statusColor, fontWeight: "bold" }}>
                                          Status: {passbookDisplayStatus}
                                        </div>
                                      </div>
                                    );
                                  })()
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td style={tableCellStyle}>
                                <span
                                  style={{
                                    color: ["Verified", "Uploaded", "Submitted", "Provided"].includes(row.status)
                                      ? "green"
                                      : ["Invalid", "Error", "Rejected", "Not Uploaded", "Not Verified", "Pending"].includes(row.status)
                                        ? "orange"
                                        : "grey",
                                    fontWeight: "bold",
                                    fontSize: "0.9em"
                                  }}
                                >
                                  {row.status}
                                </span>
                              </td>
                              <td style={tableCellStyle}>
                                {row.isEditing ? (
                                  <button
                                    type="button"
                                    style={saveButtonStyle}
                                    onClick={() => handleSave(actualIndex)}
                                  >
                                    Save
                                  </button>
                                ) : (
                                  isFieldEditable(row.key) ? (
                                    <button
                                      type="button"
                                      style={editButtonStyle}
                                      onClick={() => handleEdit(actualIndex)}
                                    >
                                      Edit
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      style={{ ...editButtonStyle, opacity: 0.5, cursor: "not-allowed" }}
                                      disabled
                                    >
                                      Edit
                                    </button>
                                  )
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Buttons Section */}
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <button
                type="submit"
                style={{ ...submitAllButtonStyle, opacity: loading ? 0.7 : 1, marginBottom: "10px" }}
                disabled={loading}
              >
                {loading
                  ? "Submitting..."
                  : !currentVendorId
                    ? "Submit Registration"
                    : "Submit"}
              </button>

              {/* Cancel button - only show when editing */}
              {currentVendorId && vendorDetails && isEditMode && (
                <button
                  type="button"
                  style={{ ...submitAllButtonStyle, backgroundColor: "#dc3545", marginLeft: "10px" }}
                  onClick={handleCancelEdit}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
          {loading && <div style={{ marginTop: '10px', textAlign: 'center', fontWeight: 'bold' }}>Processing...</div>}

          {showMap && (
            <Modal onClose={() => setShowMap(false)}>
              <h3>Select Location</h3>
              <LocationPicker
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
              />
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px' }}>
                <button
                  onClick={handleConfirmLocation}
                  style={locationButtonStyle}
                >
                  Confirm Location
                </button>
                <button
                  onClick={() => setShowMap(false)}
                  style={{ ...locationButtonStyle, backgroundColor: '#dc3545' }}
                >
                  Cancel
                </button>
              </div>
            </Modal>
          )}
        </div>
      )}
    </>
  );
};


const mobileEditBtn = {
  background: "#f0ad4e",
  color: "white",
  border: "none",
  padding: "6px 12px",
  borderRadius: "6px",
  fontSize: "11px",
  fontWeight: "bold",
  cursor: "pointer"
};

const mobileSaveBtnSmall = {
  background: "#5cb85c",
  color: "white",
  border: "none",
  padding: "6px 12px",
  borderRadius: "6px",
  fontSize: "11px",
  fontWeight: "bold",
  cursor: "pointer"
};

const mobileUploadBtnSmall = {
  background: "#5bc0de",
  color: "white",
  border: "none",
  padding: "4px 10px",
  borderRadius: "6px",
  fontSize: "11px",
  cursor: "pointer"
};

const mobileLocationBtnSmall = {
  background: "#4CAF50",
  color: "white",
  border: "none",
  padding: "8px 12px",
  borderRadius: "6px",
  fontSize: "12px",
  cursor: "pointer",
  marginTop: "8px",
  width: "100%"
};


const tableHeaderStyle = {
  border: "1px solid #ccc",
  padding: "12px",
  backgroundColor: "#e66d33",
  color: "white",
  textAlign: "center",
  fontWeight: "500",
  fontSize: "1rem"
};

const sectionHeadingStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  backgroundColor: "#f0f0f0",
  textAlign: "left",
  fontSize: "1.1rem",
  fontWeight: "bold",
  color: "#333"
};

const tableCellStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  verticalAlign: "center",
  textAlign: "center",
  fontSize: window.innerWidth < 1100 ? "12px" : "13px",
};

const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#ffffff" };

const inputStyle = {
  width: "100%",
  border: "1px solid #ccc",
  padding: "8px",
  borderRadius: "4px",
  fontSize: "13px"
};

const buttonStyle = {
  backgroundColor: "#5bc0de",
  color: "white",
  padding: "6px 12px",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "bold"
};

const editButtonStyle = { ...buttonStyle, backgroundColor: "#f0ad4e" };
const saveButtonStyle = { ...buttonStyle, backgroundColor: "#5cb85c" };

const submitAllButtonStyle = {
  backgroundColor: "#e66d33",
  color: "white",
  padding: "12px 24px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "bold"
};

const locationButtonStyle = {
  backgroundColor: "#4CAF50",
  color: "#fff",
  padding: "8px 16px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "bold",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  transition: "all 0.3s ease",
  width: "100%",
  whiteSpace: "nowrap",
};

const fileInfoStyle = {
  marginTop: "5px",
  fontSize: "0.8em",
  wordBreak: "break-all",
  textAlign: "center"
};

export default Registration;